import Vue from 'vue';

export function search (params) {
  return Vue.axios({
    url: '/api/search',
    method: 'get',
    params: params
  })
}


export function searchHistory (id) {
  return Vue.axios({
    url: '/api/search/history/' + id,
    method: 'DELETE',
  })
}

export function searchResult (params) {
  return Vue.axios({
    url: '/api/search/result',
    method: 'get',
    params: params
  })
}
